import type { Webhook, WebhookDelivery } from "@repo/shared/types";
import { del, get, patch, post } from "./_client";

export function getWebhooks() {
  return get<Webhook[]>("/internal/webhooks");
}

export function createWebhook(data: {
  name: string;
  url: string;
  events: string[];
  description?: string;
}) {
  return post<{ webhook: Webhook; secret: string }>("/internal/webhooks", data);
}

export function updateWebhook(
  id: string,
  data: {
    name: string;
    url: string;
    events: string[];
    isActive: boolean;
    description?: string;
  },
) {
  return patch<Webhook>(`/internal/webhooks/${id}`, data);
}

export function deleteWebhook(id: string) {
  return del(`/internal/webhooks/${id}`);
}

export function testWebhook(id: string) {
  return post<{ deliveryId: string }>(`/internal/webhooks/${id}/test`);
}

export function getWebhookDeliveries(webhookId: string, limit = 50) {
  return get<WebhookDelivery[]>(`/internal/webhooks/${webhookId}/deliveries?limit=${limit}`);
}
